<template>
  <div class="crushing">
    <div class="rd-header rd-header--crushing">
      <h1 class="rd-h1">{{api.title}}</h1>
    </div>
    <div class="rd-container">

      <h2>Anvisningar</h2>

      <div class="rd-island-container">
        <medium-editor
          :text="cleanData"
          ref="dyntext-editor"
          :options="{
            toolbar: {
              buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h5', 'h6', 'referenceandfootnote']
            }
          }"
          custom-tag="div"/>
      </div>

      <div v-if="resultErrorText" class="rd-island-container rd-island-container--warning">
        {{ resultErrorText }}
      </div>
      <div v-show="saveSuccess" class="rd-save-success" >Sparat</div>

      <div class="rd-actions-row">
        <mu-raised-button
          class="rd-button--green"
          label="Spara"
          icon="upload"
          primary
          @click="save()" />
      </div>
    </div>
  </div>
</template>

<script>

import vueMediumEditor from 'vue2-medium-editor'
import { reactive, toRefs, onMounted, computed } from '@vue/composition-api'
import axios from 'axios'
import { isEqual, startsWith, endsWith } from 'lodash'
import { getApplicationDynamicTextByKey } from '../store/actions'

export default {
  name: 'GeneralDynamicTextEditor',
  components: {
    'medium-editor': vueMediumEditor
  },
  setup (_, ctx) {
    const state = reactive({
      id: '',
      cleanData: '',
      changeDate: '',
      resultOkText: '',
      resultErrorText: '',
      editor: null,
      saveSuccess: false
    })
    onMounted(() => {
      window.scrollTo(0, 0)
      getDynamicText()
    })

    const api = computed(() => {
      const api = {
        'readmore': {
          dynamicTextKey: 'firstPageReadMore',
          title: 'Redigera "Läs mer"',
          get: 'application/getDynamicTextByKey',
          refresh: getApplicationDynamicTextByKey,
          update: 'application/updateDynamicText'
        }
      }
      return api[ctx.root.$route.meta.type]
    })

    async function getDynamicText () {
      let recordKey = api.value.dynamicTextKey
      axios.get(api.value.get, { params: {recordKey} })
        .then((result) => {
          if (result.data) {
            const data = result.data
            state.cleanData = data.dynamicTextWebApp
            state.changeDate = data.changeDate
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }

    function updateText (text) {
      let textKey = api.value.dynamicTextKey
      const data = {
        dynamicTextKey: textKey,
        dynamicTextWebApp: text
      }
      axios.post(api.value.update, data)
      .then(async (result) => {
        if (result.data.resultCode === 'Ok') {
          state.resultErrorText = ''
          await getDynamicText()
          api.value.refresh(ctx.root.$store, textKey)
          showSaveSuccess()
        } else {
          state.resultErrorText = result.data.message
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }

    function save () {
      let text = state.editor.api.origElements.innerHTML
      if (text && !isEqual(text, state.cleanData)) {
        text = text.replace('<p><br></p>', '')
        if (startsWith(text, '<p>') && endsWith(text, '</p>')) {
          text = text.substring(3, text.length - 4)
        }
        updateText(text)
      }
    }

    function showSaveSuccess () {
      state.saveSuccess = true
      setTimeout(() => {
        state.saveSuccess = false
      }, 5000)
    }

    return {
      ...toRefs(state),
      getDynamicText,
      save,
      api
    }
  }
}
</script>

<style lang="scss" scoped>
.view-container {
  margin-top:20px;
}

body .view-container {
  padding-top: 10px;
}
</style>


